export default {
    namespaced: true,

    state: {
        dashboard: {
            'vendasMes': null,
            'vendasMesAnterior': null,
            'vendas_do_dia': null,
            'produtosVendidosMes': null,
            'clientes': null,
            'clientes_recentes': null,
            'contas_receber': null,
            'contas_receber_mes': null,
            'vendas_da_semana': null,
            'produtos': 0,
        },
    },

    mutations: {
        SET_DASHBOARD(state, dashboard) {
            state.dashboard = dashboard;
        },
    },

}